


















import Vue from "vue";
import { Component } from "vue-property-decorator";
import { IMenuRoute } from "@/models/routes";

@Component
export default class AdminInvoicesListView extends Vue {
  public get defaultRoutes(): IMenuRoute[] {
    return [
      {
        label: this.$t("_.all"),
        to: {
          name: "adminInvoicesList_all"
        }
      },
      {
        label: this.$t("_.paid"),
        to: {
          name: "adminInvoicesList_paid"
        }
      },
      {
        label: this.$t("_.unpaid"),
        to: {
          name: "adminInvoicesList_unpaid"
        }
      },
      {
        label: this.$t("_.overdue"),
        to: {
          name: "adminInvoicesList_overdue"
        }
      },
      {
        label: this.$t("_.cancelled"),
        to: {
          name: "adminInvoicesList_cancelled"
        }
      },
      {
        label: this.$t("_.refunded"),
        to: {
          name: "adminInvoicesList_refunded"
        }
      },
      {
        label: this.$t("_.from_last_30_days"),
        to: {
          name: "adminInvoicesList_last_30_days"
        }
      },
      {
        label: this.$t("_.pending_review"),
        to: {
          name: "adminInvoicesList_pending_review"
        }
      },
      {
        label: this.$t("_.blocked"),
        to: {
          name: "adminInvoicesList_blocked"
        }
      }
    ];
  }
}
